import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import selectors from '../../../store/shared/selectors'
import { setToursAutoStart } from '../../../store/shared/currentUserDuck'
import withFadeInUpAnimation from '../../hocs/withFadeInUpAnimation'

class PageTitleBasic extends Component {
  static propTypes = {
    content: PropTypes.string,
    subContent: PropTypes.string,
    tourName: PropTypes.string,
    setToursAutoStart: PropTypes.func.isRequired,
    toursAutoStart: PropTypes.arrayOf(PropTypes.string).isRequired,
  }

  static defaultProps = {
    content: 'PageTitle',
    tourName: null,
  }

  constructor(props) {
    super(props)

    this.resetTour = () => this.props.setToursAutoStart(this.props.toursAutoStart.concat([this.props.tourName]))
  }


  render() {
    const { content, subContent, tourName } = this.props

    return (
      //Styles in index.css for #page-title
      <div>
        <div style={{display: 'flex', width: '100%'}}>
          <div id="page-title-basic">
            <div>
              <h1 style={{marginBottom: 5, paddingRight: 10}}>{content}</h1>
              <p className="text-secondary" style={{paddingRight: 10}}>{subContent}</p>
            </div>
          </div>
          {tourName &&
          <i onClick={this.resetTour}
             style={{alignSelf: 'center', fontSize: 20}}
             className="fal fa-question-circle"/>
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  toursAutoStart: selectors.getToursAutoStart(state),
})

const mapDispatchToProps = dispatch => bindActionCreators({
  setToursAutoStart,
}, dispatch)

const withRedux = connect(mapStateToProps, mapDispatchToProps)

export default withRedux(withFadeInUpAnimation(PageTitleBasic))



// WEBPACK FOOTER //
// ./src/components/ui/typography/PageTitleBasic.js